import { BillingTerm } from '../../products/constants/billing-term.enum';
import { formatTermMonths } from '../../products/lib/billing-term';
import { BillingTermMetaResponseDto } from '../../products/types/response';

export const formatOfferTerm = (billingTerms: BillingTermMetaResponseDto[], term: BillingTerm): string => {
  const meta = billingTerms.find((billingTerm) => billingTerm.term === term);
  return meta ? formatTermMonths(meta.months) : term;
};
